import * as React from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

import {
    Col,
    Row,
} from 'reactstrap';

import { ApplicationState } from '../../Store';
import { pathConstants } from '../../Utils/Constants';

import { FileSelectUpload } from '../FileSelectUpload/FileSelectUpload';

import { BorrowerPortalChildProps } from './BorrowerPortalV2';

import { PortalTextBorrowerFileUpload } from '../../Models/Api/strongbox.financialportal';
import { GetPortalText } from '../../Store/PortalAssets';

type InjectedReduxState = {
    fileUploadText?: PortalTextBorrowerFileUpload;
};

type InjectedActionCreators = {
};

type Props = BorrowerPortalChildProps & InjectedActionCreators & InjectedReduxState;

type State = {
    redirectHome: boolean;
};

export const DocumentsComponent: React.FC<Props> = (props): React.ReactElement => {
    const [redirectHome, setRedirectHome] = React.useState<boolean>(false);

    if ((redirectHome) || (!props.borrowerId) || (props.borrowerId === '')) {
        return (<Navigate to={pathConstants.linked} />);
    }

    return (
        <>
            <Row>
                <Col>
                    <h1>{props.fileUploadText?.uploadDocumentsHeader || ''}</h1>
                </Col>
            </Row>
            <Row>
                <Col className={'file-upload-container'}>
                    <FileSelectUpload
                        dark
                        submissionId={props.submissionId}
                        workspaceId={props.borrowerId}
                        onAllDone={() => {
                            setRedirectHome(true);
                        }}
                        fileUploadText={props.fileUploadText}
                    />
                </Col>
            </Row>
        </>
    );
}

export const Documents = connect<InjectedReduxState, InjectedActionCreators, BorrowerPortalChildProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            fileUploadText: GetPortalText<PortalTextBorrowerFileUpload>(appState, 'borrowerFileUpload'),
        };

        return result;
    }
)(DocumentsComponent);
